import React from "react";
import gameLogoImg from "../../../assets/imgs/support/zombies_run.png";

const CardLarge = (props) => {
    const { img, title, textDes, imgLink1, imgLink2 } = props.card;

    return (
        <div className="support__item large">
            <div className="row top">
                <div className="col l-5 m-12 c-12">
                    <div className="support__img">
                        <img src={img} alt="support - 22 Pushups" />
                    </div>
                </div>
                <div className="col l-7 m-12 c-12">
                    <div className="support__textBox">
                        <h4 className="textBox__title--mid">{title}</h4>
                        <p className="textBox__text">{textDes}</p>
                    </div>
                </div>
            </div>
            <div className="row center bottom">
                <div className="col l-3 m-12 c-12">
                    <div className="imgGameLogo">
                        <p className="text-bold">What is</p>
                        <img src={gameLogoImg} alt="" />
                    </div>
                </div>
                <div className="col l-6 m-12 c-12">
                    <div className="game-info">
                        <p className="textBox__text">
                            Zombies, Run! is an immersive running game set
                            around the fictional base camp Abel Township is a
                            virtual zombie apocalyptic world.
                        </p>

                        <div className="game-info__number">
                            <div className="game-info__number__item">
                                <p className="text-bold">~£29.50</p>
                                <p>Annual ARPU</p>
                            </div>
                            <div className="game-info__number__item">
                                <p className="text-bold">58%</p>
                                <p>subscribe annually</p>
                            </div>
                            <div className="game-info__number__item">
                                <p className="text-bold">+15%</p>
                                <p>Avg. monthly paidU</p>
                            </div>
                            <div className="game-info__number__item">
                                <p className="text-bold">+ >100%</p>
                                <p>Avg. MAUsU</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col l-3 m-12 c-12">
                    <div className="imgLink">
                        <a
                            href={imgLink1.href}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={imgLink1.img} alt="appStore" />
                        </a>

                        {imgLink2 && (
                            <a
                                href={imgLink2.href}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img src={imgLink2.img} alt="appStore" />
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardLarge;
